
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20.6 25.66"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"trash bin"}},[_c('path',{attrs:{"d":"M19.75 3.52h-5.12v-.77A2.75 2.75 0 0011.88 0H8.72A2.75 2.75 0 006 2.75v.77H.85a.85.85 0 00-.85.85v3.09a.85.85 0 00.85.85h.63l1 16.55a.85.85 0 00.85.8h14a.85.85 0 00.85-.8l.93-16.55h.63a.85.85 0 00.85-.85V4.37a.85.85 0 00-.84-.85zM7 2.75A1.76 1.76 0 018.72 1h3.16a1.76 1.76 0 011.75 1.75v.77H7zm10.2 21.91H3.44l-1-16.35h15.68zm2.4-17.35H1V4.52h18.6z"}}),_c('path',{attrs:{"d":"M6.25 22.62a.5.5 0 00.5-.5V10.21a.5.5 0 00-.5-.5.5.5 0 00-.5.5v11.91a.5.5 0 00.5.5zM10.3 22.62a.5.5 0 00.5-.5V10.21a.5.5 0 00-1 0v11.91a.5.5 0 00.5.5zM14.35 22.62a.5.5 0 00.5-.5V10.21a.5.5 0 00-.5-.5.5.5 0 00-.5.5v11.91a.5.5 0 00.5.5z"}})])])
          )
        }
      }
    